"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const helpers_1 = require("../../../lib/helpers");
const FormContext_1 = require("../../../contexts/FormContext");
const animations_1 = require("../../../lib/config/animations");
const InputContext_1 = require("../../../contexts/InputContext");
const InputError = (props) => {
    var _a;
    const { errors } = react_1.useContext(FormContext_1.FormContext);
    const { divRef, error: errorFromProps, name: fieldContextName } = react_1.useContext(InputContext_1.InputContext);
    const errorRef = react_1.useRef(null);
    const [open, setOpen] = react_1.useState(false);
    const fieldName = fieldContextName !== null && fieldContextName !== void 0 ? fieldContextName : props.name;
    const error = errorFromProps !== null && errorFromProps !== void 0 ? errorFromProps : (_a = errors.find((e) => e.attribute === fieldName)) === null || _a === void 0 ? void 0 : _a.message;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    react_1.useEffect(() => {
        setOpen(false);
        if (error) {
            const t = setTimeout(() => {
                setOpen(true);
            }, 250);
            return () => clearTimeout(t);
        }
    }, [error]);
    react_1.useEffect(() => {
        var _a, _b;
        if (error) {
            // SubmitButton doesn't have inputRef and uses <InputError name="main"/>
            if (divRef) {
                (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
            else {
                (_b = errorRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
    }, [errorRef, error, fieldName, divRef]);
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, null, open && (react_1.default.createElement(framer_motion_1.motion.div, Object.assign({}, primitiveProps, animations_1.getAnimationProps(animations_1.FadeInAnim), { ref: errorRef }),
        react_1.default.createElement("span", null, helpers_1.parseTimeBlocks(error))))));
};
exports.default = withJourney_1.default('j-input-error', InputError);
